define('SuiteCommerce.OrderStatus.OrderFinder.OrderPaymentInfo.View',
  [
    'suitecommerce_orderstatus_payment_info.tpl',
    'Backbone',
    'SuiteCommerce.OrderStatus.Configuration',
    'SuiteCommerce.OrderStatus.Utils',
    'underscore'
  ],
  function define(
    Template,
    Backbone,
    Configuration,
    Utils,
    _
  ) {
    'use strict';

    return Backbone.View.extend({
      template: Template,

      initialize: function initialize(options) {
        this.paymentData = options.paymentData;
      },

      getContext: function getContext() {
        return {
          viewElements: {
            panelTitle: {
              label: Utils.getConfigurationParameter('orderDetailsPaymentSectionLabel'),
              show: !!Utils.getConfigurationParameter('orderDetailsSummaryLabel')
            },
            paymentMethodPanelTitle: {
              label: Utils.getConfigurationParameter('orderDetailsPaymentMethodLabel'),
              show: !!Utils.getConfigurationParameter('orderDetailsPaymentMethodLabel')
            },
            creditCardEndingLabel: {
              label: Utils.getConfigurationParameter('orderDetailsPaymentSectionEndingInLabel'),
              show: !!this.paymentData.creditCardEndingNumbers
            },
            billToPanelTitle: {
              label: Utils.getConfigurationParameter('orderDetailsPaymentSectionBillingLabel'),
              show: !!Utils.getConfigurationParameter('orderDetailsPaymentSectionBillingLabel')
            }
          },
          paymentData: this.getProcessedPaymentData()
        };
      },

      getProcessedPaymentData: function getProcessedPaymentData() {
        var paymentData = this.paymentData;
        var paymentMethodsInConfiguration = Configuration.get('siteSettings.paymentmethods');
        var addressLines;
        if (paymentData.billAddress) {
          addressLines = paymentData.billAddress.split('\n');
          paymentData.billAddressName = addressLines.shift();
          paymentData.addressLines = addressLines;
        }

        if (paymentData.method && paymentData.method.id) {
          _.each(paymentMethodsInConfiguration, function findImageUrlForPaymentMethod(method) {
            if (
              paymentData.method.id === method.internalid
              && method.imagesrc.length > 0
            ) {
              paymentData.thumbnailUrl = method.imagesrc[0];
            }
          });
        }
        return paymentData;
      }
    });
  });
